import {FmlxButton, FmlxModal} from 'fmlx-common-ui';

const FeedbackModal = ({open, onClose, selectedFeedback}) => {
  const cancelButton = {
    show: true,
    label: 'Cancel',
    type: FmlxButton.Type.BASIC,
    variant: FmlxButton.Variant.OUTLINE,
    onClick: () => {
      onClose();
    },
  };
  return (
    <FmlxModal
      open={open}
      size="md"
      tertiaryButton={false}
      primaryButton={false}
      secondaryButton={cancelButton}
      title={'Message Detail'}
      onCloseClick={onClose}
    >
      <div className="modal-content">
        {selectedFeedback && (
          <div>
            <div>
              <strong>Sender: </strong>
              {selectedFeedback.teamMember}
              {selectedFeedback.name}
            </div>
            <div>
              <strong>Messages: </strong>
              <p>{selectedFeedback.comments}</p>
            </div>
          </div>
        )}
      </div>
    </FmlxModal>
  );
};

export default FeedbackModal;
